<template>
    <div>
        <Head title="Mi Suscripción" />

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="p-6">
                        <!-- Plan Actual -->
                        <div class="mb-8">
                            <h3 class="text-lg font-medium text-gray-900 mb-4">Plan Actual</h3>
                            <div class="bg-gray-50 p-6 rounded-lg">
                                <div class="flex justify-between items-center">
                                    <div>
                                        <h4 class="text-xl font-bold text-gray-900">{{ account.plan_name }}</h4>
                                        <p class="text-gray-600">${{ account.plan_price }}/mes</p>
                                    </div>
                                    <span class="px-3 py-1 text-sm font-medium rounded-full" 
                                          :class="{
                                              'bg-green-100 text-green-800': account.has_active_subscription,
                                              'bg-yellow-100 text-yellow-800': !account.has_active_subscription
                                          }">
                                        {{ account.has_active_subscription ? 'Activo' : 'Inactivo' }}
                                    </span>
                                </div>
                                <div class="mt-4">
                                    <p class="text-sm text-gray-600">
                                        {{ account.has_active_subscription 
                                            ? `Próxima renovación: ${formatDate(account.plan_expires_at)}`
                                            : 'Sin suscripción activa' }}
                                    </p>
                                </div>
                            </div>
                        </div>

                        <!-- Características del Plan -->
                        <div class="mb-8">
                            <h3 class="text-lg font-medium text-gray-900 mb-4">Características Incluidas</h3>
                            <ul class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                <li v-for="feature in account.plan_features" :key="feature" 
                                    class="flex items-center text-gray-600">
                                    <svg class="h-5 w-5 text-green-500 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
                                    </svg>
                                    {{ feature }}
                                </li>
                            </ul>
                        </div>

                        <!-- Información de Pago -->
                        <div v-if="subscription" class="mb-8">
                            <h3 class="text-lg font-medium text-gray-900 mb-4">Información de Pago</h3>
                            <div class="bg-gray-50 p-6 rounded-lg">
                                <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                                    <div>
                                        <p class="text-sm text-gray-600">ID de Suscripción</p>
                                        <p class="font-medium">{{ subscription.id }}</p>
                                    </div>
                                    <div>
                                        <p class="text-sm text-gray-600">Estado</p>
                                        <p class="font-medium capitalize">{{ subscription.status }}</p>
                                    </div>
                                    <div v-if="subscription.current_period_end">
                                        <p class="text-sm text-gray-600">Próximo Pago</p>
                                        <p class="font-medium">{{ formatDate(subscription.current_period_end) }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Acciones -->
                        <div class="flex justify-between items-center">
                            <Link href="/subscription/plans" 
                                  class="inline-flex items-center px-4 py-2 bg-gray-800 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-gray-700">
                                Cambiar Plan
                            </Link>

                            <form v-if="!account.is_on_free_plan" @submit.prevent="cancelSubscription" class="inline">
                                <button type="submit" 
                                        class="inline-flex items-center px-4 py-2 bg-red-600 border border-transparent rounded-md font-semibold text-xs text-white uppercase tracking-widest hover:bg-red-500">
                                    Cancelar Suscripción
                                </button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue'
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'

export default defineComponent({
    components: {
        Layout,
        Link,
        Head
    },

    layout: Layout,

    props: {
        account: Object,
        subscription: Object
    },

    methods: {
        formatDate(date) {
            return new Date(date).toLocaleDateString('es-ES', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            })
        },

        cancelSubscription() {
            if (confirm('¿Estás seguro de que deseas cancelar tu suscripción?')) {
                this.$inertia.post(route('subscriptions.cancel'))
            }
        }
    }
})
</script> 